import { Page } from 'components/ui';

export default function About() {
  return (
    <Page className="About">
      <h1>About</h1>
    </Page>
  );
}
